module.exports = __webpack_public_path__ + "img/aspect-ratio-4-3.7165fc31.svg";